import React, { Component } from 'react';
import PT from 'prop-types';
import cIf from 'classnames';
import { MDCChipSet } from '@material/chips';
import { Icon } from './icon';

export class Chip extends Component {
    constructor(props) {
        super(props);
        this.mdChipRef = React.createRef();
    }

    componentDidMount() {
        // Note: we need to instanciate MDCChipSet here, since it's required by Material Design
        //eslint-disable-next-line sonarjs/constructor-for-side-effects
        new MDCChipSet(this.mdChipRef.current);
    }

    render() {
        return (
            <div className="mdc-chip-set" ref={this.mdChipRef}>
                <div className="rese-chip mdc-chip">
                    <div className="mdc-chip__text">{this.props.chipText}</div>
                    {this.props.canBeRemoved ?
                        <Icon className={cIf(["rese-chip-icon", this.props.closeIcon.className])}
                              label={this.props.closeIcon.label}
                              onClick={this.props.onClick} 
                        />
                    : null }
                </div>
            </div>
        );
    }
}
Chip.propTypes = {
    chipText: PT.string,
    onClick: PT.func,
    closeIcon: PT.shape({
        className: PT.string,
        label: PT.string
    }),
    canBeRemoved: PT.bool
};
Chip.defaultProps = {
    canBeRemoved: true
};
